import { Events } from './Events';

const EventTableCE = () => {
  return (
    <Events.Root>
      <Events.Headers />
      <Events.Body />
    </Events.Root>
  );
};

export { EventTableCE };
